import(/* webpackMode: "eager", webpackExports: ["InAppBannerContainer"] */ "/vercel/path0/apps/web/components/common/in-app-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/vercel/path0/apps/web/components/common/logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingIntercomCTA"] */ "/vercel/path0/apps/web/components/common/marketing-intercom-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TheHeader"] */ "/vercel/path0/apps/web/components/common/the-header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.12_@opentelemetry+api@1.9.1_@playwright+test@1.62.1_@types+node@24.0.8_babel-plugin_lvetgih4ocjpvjw3o6hzhdr5ly/node_modules/next/dist/client/app-dir/link.js");
